// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1JDnr","buttons":"SendReceipts_buttons__3wv5-","email":"SendReceipts_email__2poEw","bookApptTitle":"SendReceipts_bookApptTitle__j89Vo"};